// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/common/v1/common.proto (package msh.common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum msh.common.v1.Weekday
 */
export const Weekday = proto3.makeEnum(
  "msh.common.v1.Weekday",
  [
    {no: 0, name: "WEEKDAY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "WEEKDAY_SUNDAY", localName: "SUNDAY"},
    {no: 2, name: "WEEKDAY_MONDAY", localName: "MONDAY"},
    {no: 3, name: "WEEKDAY_TUESDAY", localName: "TUESDAY"},
    {no: 4, name: "WEEKDAY_WEDNESDAY", localName: "WEDNESDAY"},
    {no: 5, name: "WEEKDAY_THURSDAY", localName: "THURSDAY"},
    {no: 6, name: "WEEKDAY_FRIDAY", localName: "FRIDAY"},
    {no: 7, name: "WEEKDAY_SATURDAY", localName: "SATURDAY"},
  ],
);

/**
 * @generated from enum msh.common.v1.TimeFrame
 */
export const TimeFrame = proto3.makeEnum(
  "msh.common.v1.TimeFrame",
  [
    {no: 0, name: "TIME_FRAME_UNSPECIFIED"},
    {no: 6, name: "TIME_FRAME_15MIN"},
    {no: 1, name: "TIME_FRAME_HOUR"},
    {no: 2, name: "TIME_FRAME_DAY"},
    {no: 3, name: "TIME_FRAME_WEEK"},
    {no: 4, name: "TIME_FRAME_MONTH"},
    {no: 5, name: "TIME_FRAME_YEAR"},
  ],
);

/**
 *
 * An agent represents who performed the action.
 * This is mainly used in Event to record who triggered the event
 *
 * Values can be user, device or system.
 *
 * @generated from message msh.common.v1.Agent
 */
export const Agent = proto3.makeMessageType(
  "msh.common.v1.Agent",
  () => [
    { no: 1, name: "device", kind: "message", T: Agent_Device, oneof: "agent" },
    { no: 2, name: "user", kind: "message", T: Agent_User, oneof: "agent" },
    { no: 3, name: "system", kind: "message", T: Agent_System, oneof: "agent" },
  ],
);

/**
 * @generated from message msh.common.v1.Agent.Device
 */
export const Agent_Device = proto3.makeMessageType(
  "msh.common.v1.Agent.Device",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Agent_Device"},
);

/**
 * @generated from message msh.common.v1.Agent.User
 */
export const Agent_User = proto3.makeMessageType(
  "msh.common.v1.Agent.User",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "photo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Agent_User"},
);

/**
 * @generated from message msh.common.v1.Agent.System
 */
export const Agent_System = proto3.makeMessageType(
  "msh.common.v1.Agent.System",
  () => [
    { no: 1, name: "module", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Agent_System"},
);

/**
 * @generated from message msh.common.v1.Page
 */
export const Page = proto3.makeMessageType(
  "msh.common.v1.Page",
  () => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "per_page", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "has_more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message msh.common.v1.Error
 */
export const Error = proto3.makeMessageType(
  "msh.common.v1.Error",
  () => [
    { no: 1, name: "error", kind: "enum", T: proto3.getEnumType(Error_ErrorCode) },
  ],
);

/**
 * @generated from enum msh.common.v1.Error.ErrorCode
 */
export const Error_ErrorCode = proto3.makeEnum(
  "msh.common.v1.Error.ErrorCode",
  [
    {no: 0, name: "ERROR_CODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ERROR_CODE_COULD_NOT_REACH_DEVICE", localName: "COULD_NOT_REACH_DEVICE"},
    {no: 2, name: "ERROR_CODE_COMMAND_FAILED", localName: "COMMAND_FAILED"},
    {no: 3, name: "ERROR_CODE_FILE_NOT_FOUND", localName: "FILE_NOT_FOUND"},
    {no: -1, name: "ERROR_CODE_NO_ERROR", localName: "NO_ERROR"},
  ],
);

/**
 * @generated from message msh.common.v1.Role
 */
export const Role = proto3.makeMessageType(
  "msh.common.v1.Role",
  () => [
    { no: 1, name: "role", kind: "enum", T: proto3.getEnumType(Role_RoleLevel) },
  ],
);

/**
 * @generated from enum msh.common.v1.Role.RoleLevel
 */
export const Role_RoleLevel = proto3.makeEnum(
  "msh.common.v1.Role.RoleLevel",
  [
    {no: 0, name: "ROLE_LEVEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROLE_LEVEL_VIEWER", localName: "VIEWER"},
    {no: 2, name: "ROLE_LEVEL_EDITOR", localName: "EDITOR"},
    {no: 3, name: "ROLE_LEVEL_ADMIN", localName: "ADMIN"},
  ],
);

/**
 * @generated from message msh.common.v1.ContactTime
 */
export const ContactTime = proto3.makeMessageType(
  "msh.common.v1.ContactTime",
  () => [
    { no: 1, name: "weekday", kind: "enum", T: proto3.getEnumType(Weekday) },
    { no: 2, name: "start_time", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "end_time", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.common.v1.TimeRange
 */
export const TimeRange = proto3.makeMessageType(
  "msh.common.v1.TimeRange",
  () => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message msh.common.v1.IOTCoreCommandStatus
 */
export const IOTCoreCommandStatus = proto3.makeMessageType(
  "msh.common.v1.IOTCoreCommandStatus",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(IOTCoreCommandStatus_CommandStatus) },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum msh.common.v1.IOTCoreCommandStatus.CommandStatus
 */
export const IOTCoreCommandStatus_CommandStatus = proto3.makeEnum(
  "msh.common.v1.IOTCoreCommandStatus.CommandStatus",
  [
    {no: 0, name: "COMMAND_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_STATUS_SENT", localName: "SENT"},
    {no: 2, name: "COMMAND_STATUS_NOT_EXIST_IOTCORE", localName: "NOT_EXIST_IOTCORE"},
    {no: 3, name: "COMMAND_STATUS_NOT_EXIST_DB", localName: "NOT_EXIST_DB"},
    {no: 4, name: "COMMAND_STATUS_INVALID_PARAMETERS", localName: "INVALID_PARAMETERS"},
    {no: 5, name: "COMMAND_STATUS_API_CALL_ERROR", localName: "API_CALL_ERROR"},
    {no: 6, name: "COMMAND_STATUS_API_RETRY_ERROR", localName: "API_RETRY_ERROR"},
  ],
);

